// extracted by mini-css-extract-plugin
export var errorIcon = "_ja-1";
export var nameLogo = "_ja-0";